$('form#contato').submit(function(){
	var campo = {
		"nome" 		: $('input[name=nome]', this),
		"solicitacao" 	: $('select[name=solicitacao]', this),
		"assunto" 		: $('input[name=assunto]', this),
		"email" 		: $('input[name=email]', this),
		"mensagem" 		: $('textarea[name=mensagem]', this)
	}

	var erros = [];
	$('form#contato .campo-erros ul').html("");
	
	if( campo.nome.val().length < 3 ){
		campo.nome.addClass('is-err');
		erros.push("Nome");
	} else {
		campo.nome.removeClass("is-err");
	}

	if( !campo.solicitacao.val() ){
		campo.solicitacao.addClass('is-err');
		erros.push("Solicitação");
	} else {
		campo.solicitacao.removeClass("is-err");
	}

	if( campo.assunto.val().length < 3 ){
		campo.assunto.addClass('is-err');
		erros.push("Assunto");
	} else {
		campo.assunto.removeClass("is-err");
	}

	if( !Valida.email( campo.email.val() ) ){
		campo.email.addClass('is-err');
		erros.push("E-mail");		
	}else {
		campo.email.removeClass('is-err');
	}

	if( campo.mensagem.val().length < 3 ){
		campo.mensagem.addClass('is-err');
		erros.push("Mensagem");
	} else {
		campo.mensagem.removeClass("is-err");
	}

	if( erros.length !== 0 ){
		$.each(erros, function(key, val){
			$('form#contato .campo-erros ul').append("<li>Verifique o campo <strong>\""+ val +"\"</strong>.</li>");
		});
		return false;
	}

});

$(window).on('init resize', function () {
	$('form#contato select').each(function () {
        var select = $(this);
		select.children(':first-child').text(window.innerWidth > 780
            ? select.data('placeholder')
			: 'Escolha...');
    })
}).trigger('init');

$('form#contato select').each(function () {
	var select = $(this);
	select.data('placeholder', select.children(':first-child').text().trim());
});